module.exports = __webpack_public_path__ + "img/9.aff49ced.png";